import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./vuex/store";
import Vuex from "vuex";
// import 'babel-polyfill';
import "element-ui/lib/theme-chalk/index.css";
import "nprogress/nprogress.css";
import ElementUI from "element-ui";
import NProgress from "nprogress"; //页面顶部进度条
import cookie from "js-cookie";
import imgPreview from './components/imgPreview';
import echarts from 'echarts';
import VueSweetalert2 from './plugins/vue-sweetalert2';
import VueCropper from 'vue-cropper';
import BaiduMap from 'vue-baidu-map';
import quillEditor from 'vue-quill-editor';
import Vuecopy from "vue-clipboard2";
import VideoPlayer from 'vue-video-player';
import hls from "videojs-contrib-hls";
import VueAudio from 'vue-audio-better';

Vue.config.productionTip = false;

// import 'default-passive-events' 
//Passive Event Listeners：就是告诉前页面内的事件监听器内部是否会调用preventDefault函数来阻止事件的默认行为，
//  以便浏览器根据这个信息更好地做出决策来优化页面性能。
// 当属性passive的值为true的时候，代表该监听器内部不会调用preventDefault函数来阻止默认滑动行为，
// Chrome浏览器称这类型的监听器为被动（passive）监听器。目前Chrome主要利用该特性来优化页面的滑动性能，
// 所以Passive Event Listeners特性当前仅支持mousewheel/touch相关事件。

// 引入阿里巴巴矢量图
import "./assets/icon/iconfont.css";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';

// 按需加载
const { download } = require("./api/http");
// import VueSweetalert2 from 'vue-sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';
// import fastclick from"fastclick";

// start mock
Vue.use(hls);
Vue.use(VideoPlayer);
Vue.use(Vuecopy);
Vue.use(quillEditor);
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(VueSweetalert2);
Vue.use(imgPreview);
Vue.use(VueCropper);
// fastclick.attach(document.body);
// Vue.prototype.$post = post;
// Vue.prototype.$get = get;
// Vue.prototype.$uploadFile = uploadFile;
Vue.use(BaiduMap, {
ak: '8KK7AJAt16mJbV3msx1tKtFEUi4hsqFX' // 这里替换为你的百度地图 API 密钥
});
Vue.use(VueAudio);

Vue.prototype.$cookie = cookie;
Vue.prototype.downLoad = download;
Vue.prototype.echarts = echarts;

NProgress.configure({
    showSpinner: false
});

new Vue({
    el: "#app",
    template: "<App/>",
    router,
    store,
    components: {
        App
    }
    //render: h => h(Login)
}).$mount("#app");

// 路由守卫
router.beforeEach((to, from, next) => {
    NProgress.start();
    next();
});

router.afterEach(transition => {
    NProgress.done();
});

//router.replace('/login')


// WEBPACK FOOTER //
// ./src/main.js